/**
 * Footer - Classic layout footer section
 *
 * Renders the cart summary footer for attraction pages.
 * Shared between ClassicLayout and AttractionLayout.
 */
import { CartSummaryFooter } from "../../../components/shared/CartSummaryFooter.web";
import type { PageData } from "../../../adapters/types";

interface FooterProps {
  data: PageData;
}

export function Footer({ data }: FooterProps): JSX.Element | null {
  const { footer } = data;

  if (!footer.visible) return null;

  return (
    <CartSummaryFooter
      ref={footer.cartSummaryRef}
      showOnTablet
      venue={footer.venue}
    />
  );
}
